export const baseUrl='https://api.themoviedb.org/3';
export const API_KEY="3522a8f8d1c3332e1a9bb409de4df75e";
export const imageurl='https://image.tmdb.org/t/p/original';
export const image='https://image.tmdb.org/t/p/w500/';